import { render, staticRenderFns } from "./TamamlanmayanTakipList.vue?vue&type=template&id=0bb65867&scoped=true"
import script from "./TamamlanmayanTakipList.vue?vue&type=script&lang=ts"
export * from "./TamamlanmayanTakipList.vue?vue&type=script&lang=ts"
import style0 from "./TamamlanmayanTakipList.vue?vue&type=style&index=0&id=0bb65867&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb65867",
  null
  
)

export default component.exports